import { render, staticRenderFns } from "./InvScL_List.vue?vue&type=template&id=08338168"
import script from "./InvScL_List.vue?vue&type=script&lang=js"
export * from "./InvScL_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports